export const finalConverterContent = {
  eyebrow: "INDIVIDUAL SPEED-TO-LEAD DIAGNOSTIC",
  title: "Request a Free Response Latency Audit for Your Website",
  body:
    "Our Research Lab will execute a live, non-disruptive mystery-shopper simulation on your digital intake channels (web forms, chat widgets, and SMS routing) to measure your exact first-response delay and calculate uncaptured revenue.",
  breakdownLead: "You will receive a personalized ",
  breakdownName: "Operational Intake Breakdown",
  breakdownTail: " including:",
  items: [
    "Your measured first-response latency down to the second.",
    "Your Lead Decay score relative to the national benchmark of {count} contractors.",
    "Industry best-practice recommendations for zero-delay lead interception.",
  ],
  formTitle: "Request Your Free Operational Audit",
  fields: [
    {
      id: "name",
      label: "Your Name",
      placeholder: "[ Your Name ]",
      autoComplete: "name",
    },
    {
      id: "website",
      label: "Your Website Domain",
      placeholder: "[ Your Website Domain (e.g., myroofing.com) ]",
      autoComplete: "url",
      inputMode: "url",
    },
    {
      id: "phone",
      label: "Direct Mobile Phone Number",
      placeholder: "[ Direct Mobile Phone Number ]",
      autoComplete: "tel",
      inputMode: "tel",
    },
    {
      id: "email",
      label: "Work Email Address",
      placeholder: "[ Work Email Address ]",
      autoComplete: "email",
      inputMode: "email",
    },
  ],
  submitLabel: "GENERATE MY FREE SPEED-TO-LEAD AUDIT REPORT",
  note: "100% Free Audit • Non-Disruptive Mystery Simulation • Results Delivered in 15 Minutes",
  confirmation: "Details accepted on this page. This request is not sent.",
}
